import React from 'react';

import {Card, CardContent, CircularProgress, Grid} from '@material-ui/core';

import {showNotification, Title} from 'react-admin';
import {downloadFile, ReportForm, schoolYears, showErrorNotify} from '../../components';
import env from '../../env';
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import cachedApis from "../../api/cachedApis";

const DsMaQrHS = (props) => {

    const [values, setValues] = React.useState({
        customerIds: [],
        customers: [],
    });

    const [loadingCustomers, setLoadingCustomers] = React.useState(true);

    React.useEffect(() => {
        setValues({...values});
        setLoadingCustomers(true);
        getStudentsByUnit(schoolYears[0].id);
    }, [values.isRedirect]);

    function getStudentsByUnit(schoolYearId) {
        cachedApis.getCustomerUnits(true, schoolYearId).then(rs => {
            setValues({...values, customers: rs});
            setLoadingCustomers(false);
        })
    }

    const getReport = () => {
        const customerIds = values.customerIds
        if (!customerIds || customerIds.length === 0) {
            showErrorNotify("Vui lòng chọn học sinh")
            return;
        }
        downloadFile(`${env.baseURL}/reports/dsMaQr?type=s&customerIds=${values.customerIds}`, 'ds_ma_qr.xlsx')
    };


    function onStudentSelected(value) {
        const studentIds = [];
        value.forEach(i => {
            const temp = "" + i;
            let zeroIdx = temp.indexOf("0000");
            let lastZeroIdx = -1;
            while (zeroIdx >= 0) {
                lastZeroIdx = zeroIdx;
                zeroIdx = temp.indexOf("0000", zeroIdx + 1);
            }
            if (lastZeroIdx !== -1 && lastZeroIdx < temp.length - 1) {
                let stdId = Number(temp.substr(lastZeroIdx + 4));
                if (!studentIds.includes(stdId)) {
                    studentIds.push(stdId);
                }
            }
        });
        setValues(
            {...values, customerIds: studentIds});
    }

    return (
        <Card>
            <Title title="resources.dsMaQrHS.name"/>
            <CardContent>
                <ReportForm params={values}
                    // validate={validate}
                            excelReport={getReport}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <label>Danh sách học sinh *</label>
                            <div style={{
                                maxHeight: '600px',
                                overflow: 'auto',
                                marginTop: 20
                            }}>
                                {loadingCustomers ?
                                    <CircularProgress color="secondary"/>
                                    :
                                    <TreeCheckBoxCustomInput data={values.customers}
                                                             selected={values.cuzIds}
                                                             expandTopLevel={true}
                                                             onChange={onStudentSelected}/>
                                }
                            </div>
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default compose(
    connect(null, {showNotification})
)(DsMaQrHS);
